/* Contact-page guide: fixed question prompts only. No query strings, storage or network calls. */
(function () {
  'use strict';
  const prompts = Object.freeze({
    seal: 'Job: Seal a carton\nCarton size / weight: \nSurface and storage or transit conditions: \nApproximate quantity and frequency: ',
    protect: 'Job: Protect a shipment\nItem dimensions / fragility: \nHandling, destination and any moisture concerns: \nApproximate quantity and frequency: ',
    wrap: 'Job: Wrap a pallet\nPallet size and load weight: \nHand or machine application, storage and transit: \nApproximate quantity and frequency: ',
    food: 'Job: Food-service question\nIntended use (direct food contact or outer packaging): \nFood type, temperature and duration: \nAny required compliance documents / quantity: '
  });
  function prefill(current, previous, job) {
    if (!Object.hasOwn(prompts,job)) throw Error('Unknown job');
    const other = previous && current.startsWith(previous) ? current.slice(previous.length).replace(/^\n\n/, '') : current;
    // Preserve anything the customer typed, even when changing the selected job.
    if (other.length + prompts[job].length + 2 > 3500) throw Error('Message is too long to add guide questions.');
    return prompts[job] + (other ? '\n\n' + other : '');
  }
  if (typeof module !== 'undefined' && module.exports) module.exports={prompts,prefill};
  if (typeof document === 'undefined') return;
  const guide=document.querySelector('[data-amp-help]');
  if (!guide) return;
  const form=guide.parentElement.querySelector('form.amp-enquiry__form');
  const message=form?.querySelector('textarea[name="contact[body]"]');
  if (!message) return;
  const status=guide.querySelector('[data-amp-help-status]');
  let previous='';
  for (const button of guide.querySelectorAll('[data-amp-job]')) button.addEventListener('click',()=>{
    const job=button.dataset.ampJob;
    try {
      message.value=prefill(message.value,previous,job);
      previous=prompts[job];
      const type=form.querySelector('select[name="contact[Enquiry type]"]');
      if (type) type.value='Product question';
      status.textContent='Questions added below. Fill in what you know; our team will check the options with you.';
      message.focus();
    } catch (_) {status.textContent='Your message is too long to add questions. Please use the form below as it is.';}
  });
})();
